import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { Observable } from 'rxjs';
import { PurchaseFileResponseDto } from '../dtos/purchase-file.response.dto';
import { ListPurchaseFileRequestDto } from '../dtos/list-purchase-file.request.dto';
import { CreatePurchaseFileUploadSasRequestDto } from '../dtos/create-purchase-file-upload-sas.request.dto';
import { PurchaseFileUploadSasResponseDto } from '../dtos/purchase-file-upload-sas.response.dto';
import { UploadPurchaseFileToBlobStorageRequestDto } from '../dtos/upload-purchase-file-to-blob-storage.request.dto';
import { ConfirmPurchaseFileUploadRequestDto } from '../dtos/confirm-purchase-file-upload.request.dto';
import { PurchaseFileUploadProgressModel } from '../models/purchase-file-upload-progress.model';

export abstract class PurchaseFileRepository {
  /** Step 1 of the direct upload: ask the API for a short-lived write permission. */
  abstract createUploadSas(
    request: CreatePurchaseFileUploadSasRequestDto,
  ): Observable<ApiResponse<PurchaseFileUploadSasResponseDto>>;

  /**
   * Step 2: push the bytes straight to blob storage, bypassing the API. Emits
   * progress while uploading; the transport-level details stay in infrastructure.
   */
  abstract uploadToBlobStorage(
    request: UploadPurchaseFileToBlobStorageRequestDto,
  ): Observable<PurchaseFileUploadProgressModel>;

  /** Step 3: tell the API the blob landed so it can start processing it. */
  abstract confirmUpload(
    request: ConfirmPurchaseFileUploadRequestDto,
  ): Observable<ApiResponse<PurchaseFileResponseDto>>;

  abstract list(
    request: ListPurchaseFileRequestDto,
  ): Observable<
    ApiResponse<PageableResponse<PurchaseFileResponseDto>>
  >;

  /**
   * Re-dispara la conciliacion del batch del archivo (incremental: el
   * reconciler solo procesa operaciones pendientes). Para el flujo
   * gateway-tardio: subir el gateway y re-conciliar sin re-subir nada.
   */
  abstract reconcile(
    id: string,
  ): Observable<ApiResponse<PurchaseFileResponseDto>>;

  abstract downloadErrors(
    id: string,
  ): Observable<ApiResponse<{ viewUrl: string }>>;

  abstract downloadFile(
    id: string,
  ): Observable<ApiResponse<{ viewUrl: string }>>;
}
